import React from 'react';

const CftValidationPage = () => (
  <div>
    <h2>CFT Validation</h2>
    <p>Validate CFT documents here.</p>
  </div>
);

export default CftValidationPage;